import { useRef } from 'react';

import { ArtifactCard } from './artifact-card';
import { ArtifactGroup } from './utils';
import { Icon } from '@/new/components/icon';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from '@/new/components/shadcn/dialog';

export function VersionsDialog({
  group,
  onClose,
  onTogglePublished,
  onDownload,
  togglingKey,
}: {
  group: ArtifactGroup | null;
  onClose: () => void;
  onTogglePublished: (params: { artifactId: string; versionNumber: number }) => void;
  onDownload: (artifactId: string, versionNumber: number) => void;
  togglingKey: string | null;
}) {
  // Keep the last non-null group so content doesn't collapse during exit animation
  const lastGroup = useRef(group);
  if (group) lastGroup.current = group;
  const display = group ?? lastGroup.current;

  return (
    <Dialog open={!!group} onOpenChange={(open) => !open && onClose()}>
      <DialogContent className="max-w-3xl">
        <DialogHeader>
          <DialogTitle>
            <Icon className="lucide--folder-closed" /> {display?.latest.name}
          </DialogTitle>
          <DialogDescription>View all versions of this document.</DialogDescription>
        </DialogHeader>

        <div className="mt-3 grid max-h-[480px] grid-cols-2 gap-4 overflow-y-auto pr-1">
          {display?.versions.map((version) => (
            <ArtifactCard
              key={version.versionNumber}
              artifact={version}
              onTogglePublished={onTogglePublished}
              onDownload={onDownload}
              onLinkClick={onClose}
              togglingKey={togglingKey}
            />
          ))}
        </div>
      </DialogContent>
    </Dialog>
  );
}
